export const MTS_MONEY_DEFAULT_TITLE = 'МТС Деньги'
export const MTS_MONEY_DEFAULT_DESCRIPTION = 'МТС Деньги'
